import { render, staticRenderFns } from "./ListUploadedFiles.vue?vue&type=template&id=0639355e&scoped=true"
import script from "./ListUploadedFiles.vue?vue&type=script&lang=js"
export * from "./ListUploadedFiles.vue?vue&type=script&lang=js"
import style0 from "./ListUploadedFiles.vue?vue&type=style&index=0&id=0639355e&prod&scoped=true&lang=css"
import style1 from "./ListUploadedFiles.vue?vue&type=style&index=1&id=0639355e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639355e",
  null
  
)

export default component.exports